import { CohortShareContextQueryDocument } from "@pathwright/graphql-client/src/generated"

export default CohortShareContextQueryDocument
